import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourSettingsHeader, colourMasterLightest } from 'Styles/colors.css';
import WveStyleElementControl from './WveStyleElementControl/WveStyleElementControl';
import WveStyleElementLabel from './WveStyleElementLabel/WveStyleElementLabel';

const Button = styled.button`
  opacity: ${props => (
    props.disabled ? 0.4 : 1
  )} !important;
  pointer-events: ${props => (
    props.disabled ? 'none' : 'auto'
  )};
`;

export default class WveStyleElement extends Component {
  render() {
    const { field, value, updateFunction, removeFunction, disabled, className } = this.props;

    const fieldClassNames = field.className ? field.className : '';

    const styleOverrides = [];

    styleOverrides.backgroundColor = field.subProperty ? colourMasterLightest : null;
    styleOverrides.paddingBottom = field.subProperty ? '5px' : '15px';
    styleOverrides.marginTop = (field.inputType === 'divider') ? '10px' : styleOverrides.marginTop;
    styleOverrides.marginBottom = (field.inputType === 'divider') ? '5px' : styleOverrides.marginBottom;
    styleOverrides.paddingBottom = (field.inputType === 'divider') ? '0' : styleOverrides.paddingBottom;

    return (
      <div
        key={`form-group-${field.label}`}
        style={{ display: 'flex', alignItems: 'center', ...styleOverrides }}
        className={`no-border p-t-0 p-l-10 m-r-0 m-l-0 ${className} ${fieldClassNames}`}
      >
        <WveStyleElementLabel
          key={`form-field-${field.label}`}
          label={field.label}
          type={field.inputType}
        />

        <WveStyleElementControl
          key={`form-control-${field.label}`}
          {...field}
          value={value}
          updateFunction={updateFunction}
          disabled={disabled}
        />

        {
          removeFunction &&
          <Button
            disabled={disabled}
            type="button"
            className="btn bg-transparent no-border"
            style={{ width: '15%' }}
            onClick={() => removeFunction(field.mapping)}
          >
            <i className="fa fa-trash-o" />
          </Button>
        }
      </div>
    );
  }
}

WveStyleElement.propTypes = {
  removeFunction: PropTypes.func,
  updateFunction: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.bool,
  ]),
  field: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

WveStyleElement.defaultProps = {
  removeFunction: null,
  updateFunction: () => {},
  disabled: false,
  className: '',
  field: [],
  value: 0,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/components/WveSettingsPanel/WveStyleElement/WveStyleElement.jsx